import React from "react";
import TextFieldMUI from "material-ui/TextField";
import { FormControl, FormHelperText } from "material-ui/Form";
import "./index.css";

const TextField = ({ input, className = " ", label, meta: { touched, error }, ...custom }) => (
  <FormControl className={`text-field ${className}`}>
    <TextFieldMUI label={label} error={touched && !!error} {...input} {...custom} />
    {touched && !!error && <FormHelperText error>{error}</FormHelperText>}
  </FormControl>
);

export default TextField;



// WEBPACK FOOTER //
// ./src/components/FormElements/TextField/index.js